<template>
  <div>
    <form class="form" @submit.prevent="">
      <div class="pb-8 form-fields">
        <div class="grid grid-cols-3 gap-6">
          <VFormSelect
            label="Product*"
            placeholder="Find a product by name..."
            :options="products"
            optionKey="netsuite_name"
            :error="errors.product"
            :showFilterInput="true"
            :classes="{ options: 'max-h-74' }"
            :initialSelectedOption="editableGroup.product != undefined ? editableGroup.product : ''"
            @onSelect="value => handleSetField('product', value)"
            @filter="text => $emit('filter', text)"
          />
          <VFormInput
            label="Porcentage Reward*"
            placeholder="Enter porcentage Value"
            :error="errors.reward"
            :reset="!fieldsData.reward"
            :initialValue="editableGroup.reward"
            @update="value => handleSetField('reward', value)"
          />
          <VFormInput
            label="Shopify Porcentage Reward*"
            placeholder="Enter porcentage Value"
            :error="errors.shopify_reward"
            :reset="!fieldsData.shopify_reward"
            :initialValue="editableGroup.shopify_reward"
            @update="value => handleSetField('shopify_reward', value)"
          />
        </div>
      </div>
    </form>

    <!-- Owned products table -->
    <div class="border-none shared-table-container">
      <div class="shared-table-innermost-container">
        <table class="shared-table">
          <thead>
            <tr class="bg-transparent shared-table-headings">
              <th
                v-for="(header, index) in $options.tableHeaders"
                :key="`heading-${index}`"
                class="shared-table-headings-heading text-ricoma-gray-700"
              >
                <div class="flex items-center justify-center">
                  {{ header }}
                </div>
              </th>
              <th class="shared-table-headings-heading text-ricoma-gray-700">
                <div class="flex items-center justify-center">Actions</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="tagProducts.length === 0">
              <td colspan="5">
                <div class="flex items-center justify-center py-6">-- EMPTY --</div>
              </td>
            </tr>
            <tr
              v-else
              v-for="(data, index) in tagProducts"
              :key="`data-${index}`"
              class="shared-table-cells odd:bg-ricoma-gray-200"
            >
              <td class="shared-table-cells-cell">{{ data.product.netsuite_name }}</td>
              <td class="shared-table-cells-cell">{{ '% ' + data.reward || ' - ' }}</td>
              <td class="shared-table-cells-cell">{{ '% ' + data.shopify_reward || ' - ' }}</td>
              <td class="shared-table-cells-cell">
                <div class="flex justify-center">
                  <button class="mr-2 button-round edit" @click="handleSetEditable(data)">
                    <VSvgIcon name="pencil" class="h-5" />
                  </button>
                  <button
                    class="shared-table-cells-button round delete"
                    @click="handleDeleteProduct(data.id)"
                  >
                    <VSvgIcon name="trash" class="h-5" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- modal buttons -->
    <div class="form-buttons">
      <button class="form-buttons-cancel" type="button" @click="() => $emit('close')">
        Cancel
      </button>
      <button
        type="button"
        class="form-buttons-proceed"
        :disabled="formLoading"
        @click="handleSubmit(handleProceed)()"
      >
        <BeatLoader
          v-if="formLoading"
          color="#FAFAFA"
          :size="0.875"
          sizeUnit="rem"
          class="flex items-center"
        />
        <span v-else>Add</span>
      </button>
    </div>
  </div>
</template>

<script>
import { formMixin } from '@/mixins';

import VSvgIcon from '@/components/base/VSvgIcon';
import VFormInput from '@/components/base/VFormInput';
import VFormSelect from '@/components/base/VFormSelect';

const TABLE_HEADERS = ['Product Name', 'Porcentage Reward', 'Shopify Reward'];

export default {
  name: 'PayoutTagProductsForm',
  components: { VSvgIcon, VFormInput, VFormSelect },
  mixins: [
    formMixin(
      {
        product: null,
        reward: '',
        shopify_reward: '',
      },
      ['product'],
    ),
  ],
  data() {
    return {
      editableGroup: {},
    };
  },
  props: {
    products: {
      type: Array,
      required: false,
      default: () => [],
    },
    tagProducts: {
      type: Array,
      required: false,
      default: () => [],
    },
    tagId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    editable() {
      return this.editableGroup && !!Object.keys(this.editableGroup).length;
    },
  },
  methods: {
    handleSetEditable({ ...res }) {
      this.editableGroup = {
        ...res,
      };
    },
    handleProceed(data) {
      this.handleAddProduct(data);
      this.handleResetFields();
      this.handleResetErrors();
      this.editableGroup = {};
    },
    async handleAddProduct({ product, ...rest }) {
      const data = {
        product_id: product.id,
        referral_payout_tag_id: this.tagId,
        ...rest,
      };
      const res = this.editable
        ? await this.$http.post(`admin/referral-payout-tag-product/${this.editableGroup.id}`, data)
        : await this.$http.post(`admin/referral-payout-tag-product`, data);
      this.$emit('update', res.data.data);
    },
    async handleDeleteProduct(id) {
      const res = await this.$http.delete(`admin/referral-payout-tag-product/${id}`);
      this.$emit('update', res.data.data);
    },
  },
  created() {
    this.$options.tableHeaders = TABLE_HEADERS;
  },
};
</script>
